import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "";
export const method = "GET";
export const operationId = "workwearExpressCustomisationPlatformFrontendExistingCustomisationsRepositoryV1GetExistingCustomisationsWithCartGet";
export const path = "/V1/customisations/mine/saved";
export type Response = Response200 | Response401 | ResponseDefault;
export type Response200 = Definitions.WorkwearExpressCustomisationPlatformFrontendDataFullCustomisationInterface[];
export type RespKeys = (keyof Definitions.WorkwearExpressCustomisationPlatformFrontendDataFullCustomisationInterface)[];
export type Response401 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "getJSON">;
export function execute<T extends RespKeys | undefined>(effects: MinimalEffects, fields?: T): T extends RespKeys ? Observable<Pick<Definitions.WorkwearExpressCustomisationPlatformFrontendDataFullCustomisationInterface, T[number]>[]> : Observable<Response200> {
    return effects.getJSON(effects.apiUrl(operationId)(path, undefined, fields), effects.restHeaders({})) as any;
}
